import _classCallCheck from "/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var InvalidPropertyException = /*#__PURE__*/function (_Error) {
  _inherits(InvalidPropertyException, _Error);

  function InvalidPropertyException(message) {
    var _this;

    _classCallCheck(this, InvalidPropertyException);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InvalidPropertyException).call(this));
    _this.message = message;
    _this.name = "InvalidPropertyException";
    return _this;
  }

  return InvalidPropertyException;
}(_wrapNativeSuper(Error));

export { InvalidPropertyException as default };